export default class TextHelpers {

	static kebabToTitleCase(text) {
		if (!text) return;
		let str = text.replace('-', ' ');
		return str.replace(/\w\S*/g, function (txt) {
			return (
				txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
			);
		});
	}

	static kebabToPascalCase(text) {
		return this.kebabToTitleCase(text).split(' ').join('');
	}

	static camelToTitleCase(text) {
		if (!text) return;
		let result = text.replace(/([A-Z])/g, " $1");
		return result.charAt(0).toUpperCase() + result.slice(1);
	}
}